import React from 'react';
import { Box, Grid, CardContent, Card } from '@mui/material';
import PropTypes from 'prop-types';
import { TIPO_USUARIO as tipoUsuario } from '../../../../consts/tipoUsuario';
import Chip from '@mui/material/Chip';

import '../seccionProfesional.scss';
export default function SeccionPreviewProfesional({ profesional, idTipoUsuario, instituciones }) {
    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
                sx={{
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                    color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                    borderRadius: 0,
                    fontSize: '0.75rem',
                    ...sx,
                    padding: 1
                }}
                {...other}
            />
        );
    }

    ItemR.propTypes = {
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    return (
        <>
            {(profesional.idProfesional > 0) && (idTipoUsuario == tipoUsuario.INTERNO) &&
                <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
                    <CardContent>
                        <strong>
                            Profesional
                        </strong>
                        <Grid container spacing={0.5}>
 <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                                <ItemR className='paciente-info-container-col'>
                                    <div className='paciente-info-content'>
                                        <strong>ID</strong>
                                        {profesional.idProfesional}
                                    </div>
                                    <div className='paciente-info-content'>
                                        <strong>Nombre</strong>
                                        {profesional.apellido}
                                        {profesional.nombre}
                                    </div>
                                    <div className='paciente-info-content'>
                                        <strong>Documento</strong>
                                        {profesional.tipoDoc} {profesional.numeroDoc}
                                    </div>
                                </ItemR>
                            </Grid>
                        </Grid>
                        {
                            instituciones.length > 0 &&
                            <>
                                <strong>
                                    Instituciones
                                </strong>
                                <br />
                                <div className='paciente-info-instituciones'>
                                    {instituciones.map((institucion, index) => <Chip key={institucion + index} label={institucion.nombre} className='chip-preview' />)}
                                </div>
                            </>
                        }
                    </CardContent>
                </Card>
            }
        </>
    )

};